<template lang="pug">
	.appr-form(v-if="initData")
		form(@submit.prevent="sendForm")
			//-h2.heading-2 Mi ez az egész
			//- Átmeneti cím OTP demó céljából
			h2.heading-2 Hogyan használja a kalkulátort?
			p Ki tudja számolni, hogy jelenleg mekkora egy adott lakás vagy ház reális értéke, de azt is, hogy miként változott az ára az elmúlt években. Az értékbecsléshez nem kell mást tennie, mint beírni az ingatlan alapadatait.
			fieldset.appr-fieldset
				legend
					h3.heading-2 Ingatlan címe
				FormRow.appr-form-row
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Irányítószám
					VueFormControl(slot="input", error-position="right")
						VueSettlementSelector(slot="input", v-model="settlement", :settlements="settlements", :has-error="$v.model.irszam.$dirty && ($v.model.irszam.$invalid || $v.model.telepules.$invalid)", @on-zip-change="$emit('on-zip-change', $event)", @change="$v.model.irszam.$touch()", :max-width="65")
						template(slot="error")
							VueErrorMessage(v-if="$v.model.irszam.$dirty && !$v.model.irszam.required") Kérjük, adja meg az irányítószámát!
							VueErrorMessage(v-if="zipSearchState == loadingStates.IDLE && $v.model.irszam.$dirty && $v.model.irszam.required && (!$v.model.irszam.numeric || !$v.model.irszam.minLength || !$v.model.telepules.required )") Kérjük ellenőrizze, hogy helyesen adta-e meg irányítószámát!
				FormRow.appr-form-row
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Cím
					template(v-slot:input="props")
						VueFormControl(error-position="right", addon-position="bottom")
							VueInput(slot="input", v-model="model.cim", maxlength="50", :has-error="$v.model.cim.$dirty && $v.model.cim.$invalid", @blur="$v.model.cim.$touch()", :max-width="300", :has-addon="true")
							.appr-addon(slot="addon", :id="props.id.addon") pl.: Nádor utca vagy Szabadság tér
							template(slot="error")
								VueErrorMessage(v-if="$v.model.cim.$dirty && !$v.model.cim.required") Kérjük, adja meg az ingatlan címét!
								VueErrorMessage(v-if="$v.model.cim.$dirty && !$v.model.cim.minLength") Kérjük ellenőrizze, hogy helyesen adta-e meg az ingatlan címét!
				FormRow.appr-form-row
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Házszám
					VueFormControl(slot="input", error-position="right")
						VueInput(slot="input", v-model="model.hazszam", maxlength="10", :has-error="$v.model.hazszam.$dirty && $v.model.hazszam.$invalid", @blur="$v.model.hazszam.$touch()", :max-width="140")
						template(slot="error")
							VueErrorMessage(v-if="$v.model.hazszam.$dirty && !$v.model.hazszam.required") Kérjük, adja meg a házszámot!
			fieldset.appr-fieldset
				legend
					h3.heading-2 Épület paraméterei
				FormRow.appr-form-row.appr-form-row--radio.appr-form-row--radio-inline-mobile
					- var tipusLabel = "Típus"
					.appr-label(slot="label", aria-hidden="true")=tipusLabel
					VueRadioGroup(slot="input", v-model="model.tipus", legend=tipusLabel, :isLegendHidden="true" :options="initData.tipusok", :has-error="$v.model.tipus.$dirty && $v.model.tipus.$invalid")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg az ingatlan típusát!
				FormRow.appr-form-row.appr-form-row--radio
					- var epitesIdejeLabel = "Építés ideje"
					- var epitesIdejeErrorMsg = "Kérjük, adja meg az ingatlan építési idejét!"
					.appr-label(slot="label", aria-hidden="true")=epitesIdejeLabel
					VueRadioGroup(v-if="!isMobile", slot="input", v-model="model.epitesIdeje", legend=epitesIdejeLabel, :isLegendHidden="true", :has-error="$v.model.epitesIdeje.$dirty && $v.model.epitesIdeje.$invalid", ref="radio-group", :options="constructionDateOptions")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError", :aria-hidden="true")=epitesIdejeErrorMsg
					template(v-if="isMobile", v-slot:input="props")
						div
							VueSelect(v-model="model.epitesIdeje", :id="props.id.input")
								VueSelectOption(v-for="(item, index) in constructionDateOptions",
												:value="item.key", :index="index", :key="item.key", :text="item.value"
												:label-id="props.id.input+'-label'")
							VueErrorMessage(v-if="$v.model.epitesIdeje.$dirty && $v.model.epitesIdeje.$invalid", :aria-hidden="true")=epitesIdejeErrorMsg
				transition(name="dropdown")
					.appr-input-dropdown(v-if="model.epitesIdeje != null" :class="{'second' : model.epitesIdeje === false}")
						transition(name="fade" mode="out-in")
							.input-dropdown(v-if="model.epitesIdeje === true" key="ageInput")
								FormRow.appr-form-row
									template(v-slot:label="props")
										label.appr-label(:for="props.id.input") Évszám
									VueFormControl(slot="input", error-position="right")
										VueInput(slot="input", type="tel", v-model="model.evszam", maxlength="4", :has-error="$v.model.evszam.$dirty && $v.model.evszam.$invalid", @blur="$v.model.evszam.$touch()", :max-width="65")
										template(slot="error")
											VueErrorMessage(v-if="$v.model.evszam.$dirty && !$v.model.evszam.required") Kérjük, adja meg a pontos évszámot!
											VueErrorMessage(v-if="$v.model.evszam.$dirty && $v.model.evszam.required && (!$v.model.evszam.numeric || !$v.model.evszam.minLength || !$v.model.evszam.between )") Kérjük ellenőrizze, hogy helyesen adta-e meg a pontos évszámot!
							.appr-radio-dropdown(v-else key="ageRadio")
								FormRow.appr-form-row.appr-form-row--radio
									- var korokLabel = "Épület kora"
									.appr-label(slot="label", aria-hidden="true")=korokLabel
									VueRadioGroup(slot="input", v-model="model.kor", legend=korokLabel, :isLegendHidden="true", :options="initData.korok", :has-error="$v.model.kor.$dirty && $v.model.kor.$invalid")
										template(v-slot="{ hasError }")
											VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg az épület korát!
				FormRow.appr-form-row.appr-form-row--radio
					- var homlokzatAllapotLabel = "Homlokzat állapota"
					.appr-label(slot="label", aria-hidden="true")=homlokzatAllapotLabel
					VueRadioGroup(slot="input", v-model="model.homlokzatAllapot" legend=homlokzatAllapotLabel, :isLegendHidden="true", :options="initData.homlokzatok", :has-error="$v.model.homlokzatAllapot.$dirty && $v.model.homlokzatAllapot.$invalid")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg a homlokzat állapotát!

				FormRow.appr-form-row.appr-form-row--radio(v-if="model.tipus == buildingTypes.TARSAS_DUMMY")
					- var falSzerkezetLabel = "Fal szerkezete"
					.appr-label(slot="label", aria-hidden="true")=falSzerkezetLabel
					VueRadioGroup(slot="input", v-model="model.falSzerkezet" legend=falSzerkezetLabel, :isLegendHidden="true", :options="initData.falak", :has-error="$v.model.falSzerkezet.$dirty && $v.model.falSzerkezet.$invalid")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg a falszerkezet típusát!
				FormRow.appr-form-row(v-if="model.tipus == buildingTypes.CSALAD_DUMMY")
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Telek mérete
					template(v-slot:input="props")
						VueInput(type="tel", v-model="model.telekMeret", maxlength="4", :has-error="$v.model.telekMeret.$dirty && $v.model.telekMeret.$invalid", @blur="$v.model.telekMeret.$touch()" :max-width="80")
						span.appr-subfieldset__label(:id="props.id.addon") négyzetméter
						VueErrorMessage(v-if="$v.model.telekMeret.$dirty && $v.model.telekMeret.$invalid", position="right") Kérjük, adja meg a telek méretét!
			fieldset.appr-fieldset
				legend
					h3.heading-2 Ingatlan paraméterei
				FormRow.appr-form-row
					template(v-slot:label="props")
						.appr-label-container
							label.appr-label(:for="props.id.input") Alapterület
							VueTooltip.bottom(role="tooltip", aria-hidden="true", anchor="center left", self="top middle", :offset="[0, 20]", :use-aria-expanded="true", :use-aria-controls="true")
								p A földszint/emelet területe 100%-ig, a tetőtér 85%-ig, míg az egyéb (pince, garázs, erkély) ház- vagy lakásrészek 50%-ig számítanak bele a területbe. További példák lentebb, a gyakran ismételt kérdéseknél találhatók.
					template(v-slot:input="props")
						VueInput(slot="input", type="tel", v-model="model.alapterulet", maxlength="4", :has-error="$v.model.alapterulet.$dirty && $v.model.alapterulet.$invalid", :has-addon="true", @blur="$v.model.alapterulet.$touch()" :max-width="60")
						span.appr-subfieldset__label(slot="addon", :id="props.id.addon") négyzetméter
						VueErrorMessage(position="right", v-if="$v.model.alapterulet.$dirty && $v.model.alapterulet.$invalid") Kérjük, adja meg az ingatlan alapterületét!
				FormRow.appr-form-row.appr-form-row--input-group
					template(v-slot:label="props")
						.appr-label-container
							span.appr-label(aria-hidden="true") Szobák száma
							VueTooltip.bottom(role="tooltip", aria-hidden="true", anchor="center left", self="top middle", :offset="[0, 20]", :use-aria-expanded="true", :use-aria-controls="true")
								p A lakószoba 8-12 m<sup>2</sup> között félszobának, 12 m<sup>2</sup> felett teljes szobának, míg 30 m<sup>2</sup> felett 2 db teljes szobának számít. További példák lentebb, a gyakran ismételt kérdéseknél találhatók.
					template(v-slot:input="props")
						fieldset.appr-fieldset
							legend.sr-only Szobák száma
							VueInput(:id="props.id.input + '_1'", type="tel", v-model="szobakSzama", maxlength="4", :has-error="$v.model.szobakSzama.$dirty && ($v.model.szobakSzama.$invalid || $v.szobakSzama.$invalid || $v.felszobakSzama.$invalid)", :has-tooltip="true", @blur="$v.model.szobakSzama.$touch()" :max-width="60")
							label.appr-subfieldset__label(:for="props.id.input  + '_1'")  egész #[span.sr-only szoba]
							VueInput(:id="props.id.input + '_2'", type="tel", v-model="felszobakSzama", maxlength="4", :has-error="$v.model.szobakSzama.$dirty && ($v.model.szobakSzama.$invalid || $v.szobakSzama.$invalid || $v.felszobakSzama.$invalid)", :has-tooltip="true", @blur="$v.model.szobakSzama.$touch()" :max-width="60")
							label.appr-subfieldset__label(:for="props.id.input + '_2'") félszoba
							span.appr-addon 12m#[sup 2] alatti szoba félszobának számít
							VueErrorMessage(v-if="$v.model.szobakSzama.$dirty && ($v.model.szobakSzama.$invalid || $v.szobakSzama.$invalid || $v.felszobakSzama.$invalid)") Legalább egy szoba vagy félszoba megadása közelező!
				FormRow.appr-form-row.appr-form-row--radio
					- var allapotokLabel = "Állapot"
					.appr-label(slot="label", aria-hidden="true")=allapotokLabel
					VueRadioGroup(slot="input", v-model="model.allapot", legend=allapotokLabel, :isLegendHidden="true", :options="initData.allapotok", :has-error="$v.model.allapot.$dirty && $v.model.allapot.$invalid")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg az ingatlan állapotát!
				template(v-if="model.tipus == buildingTypes.TARSAS_DUMMY")
					FormRow.appr-form-row.appr-form-row--radio
						- var emeletiLakasLabel = "Emeleti lakás"
						.appr-label(slot="label", aria-hidden="true")=emeletiLakasLabel
						VueRadioGroup(slot="input", v-model="model.emeletiLakas", legend=emeletiLakasLabel, :isLegendHidden="true", :options="[{key: true, value: 'Igen'},{key: false, value: 'Nem'}]", :has-error="$v.model.emeletiLakas.$dirty && $v.model.emeletiLakas.$invalid")
							template(v-slot="{ hasError }")
								VueErrorMessage(v-if="hasError", :aria-hidden="true") Kérjük, adja meg az ingatlan emeleti lakás-e!
				FormRow.appr-form-row.appr-form-row--radio
					- var komfortFokozatLabel = "Komfortfokozat"
					.appr-label-container(slot="label")
						.appr-label(aria-hidden="true")=komfortFokozatLabel
						VueTooltip.bottom(role="tooltip", aria-hidden="true", anchor="center left", self="top middle", :offset="[0, 20]", :use-aria-expanded="true", :use-aria-controls="true")
							p Azt a közművesített ingatlant tekintjük összkomfortosnak, amely rendelkezik legalább egy 12 m#[sup 2]-t meghaladó alapterületű lakószobával, valamint főzőhelyiséggel, fürdőhelyiséggel, WC-vel, melegvíz-ellátással és központos fűtési móddal.
					VueRadioGroup(slot="input", v-model="model.komfortFokozat", legend=komfortFokozatLabel, :isLegendHidden="true", :options="initData.komfortok", :has-error="$v.model.komfortFokozat.$dirty && $v.model.komfortFokozat.$invalid")
						template(v-slot="{ hasError }")
							VueErrorMessage(v-if="hasError") Kérjük, adja meg az ingatlan komfortfokozatát!
			fieldset#appr-fs-personal.appr-fieldset
				legend
					h3.heading-2 Az Ön elérhetőségei
				p(v-if="type == formTypes.CUSTOMER || type == formTypes.VENDOR") Kérjük adja meg elérhetőségét, ahová elküldhetjük a részletes bírálatot.
				FormRow.appr-form-row(v-if="type == formTypes.CUSTOMER || type == formTypes.VENDOR")
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Az ön neve
					VueFormControl(slot="input", error-position="right")
						VueInput(slot="input", v-model="model.nev", maxlength="50", :has-error="$v.model.nev.$dirty && $v.model.nev.$invalid", @blur="$v.model.nev.$touch()", :max-width="380")
						template(slot="error")
							VueErrorMessage(v-if="$v.model.nev.$dirty && !$v.model.nev.required") Kérjük, adja meg a teljes nevét!
							VueErrorMessage(v-if="$v.model.nev.$dirty && (!$v.model.nev.minLength || !$v.model.nev.pattern)") Kérjük ellenőrizze, hogy megfelelően írta-e be a nevét!
				FormRow.appr-form-row
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input")
							span(v-if="type == formTypes.ADMINISTRATOR") Ügyintéző email címe
							span(v-else) Email címe
					VueFormControl(slot="input", error-position="right")
						VueInput(slot="input", type="email", v-model="model.email", maxlength="50", :has-error="$v.model.email.$dirty && $v.model.email.$invalid", @blur="$v.model.email.$touch()", :max-width="380")
						template(slot="error")
							VueErrorMessage(v-if="$v.model.email.$dirty && !$v.model.email.required") Kérjük, adja meg e-mail címét!
							VueErrorMessage(v-if="$v.model.email.$dirty && !$v.model.email.email") Kérjük ellenőrizze, hogy helyesen adta-e meg az e-mail címét!

				FormRow.appr-form-row(v-if="type == formTypes.CUSTOMER || type == formTypes.VENDOR")
					template(v-slot:label="props")
						label.appr-label(:for="props.id.input") Mobiltelefonszáma
					VueFormControl(slot="input", error-position="right")
						VueMobilephoneInput(slot="input", v-model="model.telefon", maxlength="11", :has-error="$v.model.telefon.$dirty && $v.model.telefon.$invalid", @blur="$v.model.telefon.$touch()", postfixed, prefixed, :max-width="150")
						template(slot="error")
							VueErrorMessage(v-if="$v.model.telefon.$dirty && !$v.model.telefon.required && ((type == formTypes.VENDOR && model.megkeresesHozzajarulas) || (type == formTypes.CUSTOMER && model.ingatlanhitel))") Kérjük, adja meg mobiltelefonszámát!
							VueErrorMessage(v-if="$v.model.telefon.$dirty && !$v.model.telefon.pattern") Kérjük ellenőrizze, hogy megfelelően adta-e meg mobiltelefonszámát.
			template(v-if="type == formTypes.CUSTOMER")
				FormRow#appr-fs-loan.appr-form-row.appr-form-row--radio
					template(v-slot:label="props")
						- var ingatlanhitelLabel = "Szeretne ingatlanhitelt igényelni a vásárláshoz"
						label.appr-label(:for="props.id.input" aria-hidden="true")=ingatlanhitelLabel
					template(slot="input")
						VueRadioGroup.appr-lastgroup(slot="input", v-model="model.ingatlanhitel", legend=ingatlanhitelLabel, :options="[{key: true, value: 'Igen'},{key: false, value: 'Nem'}]", :has-error="$v.model.ingatlanhitel.$dirty && $v.model.ingatlanhitel.$invalid", :isLegendHidden="true")
							p#radio-description Ha szeretne hitelt igényelni, akkor kollégánk felveszi Önnel a kapcsolatot telefonon.
								br
								a(:href="contactDataManagementDocumentUrl", target="_blank") Kapcsolatfelvételi adatkezelési tájékoztató

			FormRow.appr-form-row(v-if="captchaImg")
				template(v-slot:label="props")
					label.appr-label(:for="props.id.input") Írja be a képen látható kódot
				VueFormControl(slot="input", error-position="right")
					template(slot="input")
						VueCaptcha(v-model="model.captchaText", :img="`data:image/jpeg;base64,${captchaImg}`", :has-error="$v.model.captchaText.$dirty && $v.model.captchaText.$invalid", maxlength="50", :max-width="80")
						template(slot="error")
							VueErrorMessage(slot="error", v-if="$v.model.captchaText.$dirty && !$v.model.captchaText.required") Kérjük, adja meg a képen látható kódot!
			hr
			.appr-form__consent
				#appr-data-consent-wrapper.appr-form-row.appr-form-row--block(v-if="type == formTypes.CUSTOMER || type == formTypes.VENDOR")
					//- VueFormControl
					VueCheckbox#appr-data-consent(v-model="model.hozzajarulas", :has-error="$v.model.hozzajarulas.$dirty && $v.model.hozzajarulas.$invalid") Az értékbecslési szolgáltatás igénybevételével hozzájárulok ahhoz, hogy az OTP Bank Nyrt. és az OTP Ingatlanpont Kft. az #[a(:href="appraisalDataManagementDocumentUrl", target="_blank") Adatkezelési tájékoztatónak] megfelelően kezelje a személyes adataimat.
					VueErrorMessage(position="bottom", v-if="$v.model.hozzajarulas.$dirty && !$v.model.hozzajarulas.checked") A mező kitöltése kötelező!
				#appr-contact-consent-wrapper.appr-form-row.appr-form-row--block(v-if="type == formTypes.VENDOR")
					VueCheckbox#appr-contact-consent(slot="input", v-model="model.megkeresesHozzajarulas") Hozzájárulok, hogy az OTP Ingatlanpont Kft. emailen, telefonon keresztül megkeressen az értékbecslési szolgáltatással kalkulált ingatlannal kapcsolatban és személyre szabott közvetítési ajánlatot tegyen az #[a(:href="personalizedOfferDataManagementDocumentUrl", target="_blank") Adatkezelési tájékoztató] és az #[a(:href="personalizedOfferDataProtectionDocumentUrl", target="_blank") Adatvédelmi Szabályzat] alapján.

			VueButton#appr-fs-submit.appr-button(slot="input", type="submit", :disabled="submitState == loadingStates.IN_PROGRESS") {{submitState == loadingStates.IDLE ? 'Mehet' : 'Pillanat...'}}
			span.appr-form-loading(v-if="submitState == loadingStates.IN_PROGRESS") Most kalkuláljuk az ingatlan értékét
</template>

<script>
import VueRadioGroup from '@ui-common/vue-radio-group';
import VueInput from '@ui-common/vue-input';
import { VueSelect, VueSelectOption } from '@ui-common/vue-select';
import VueMobilephoneInput from '@ui-common/vue-mobilephone-input';
import VueCaptcha from '@ui-common/vue-captcha';
import VueCheckbox from '@ui-common/vue-checkbox';
import VueTooltip from '@ui-common/vue-tooltip';
import VueErrorMessage from '@ui-common/vue-error-message';
import VueButton from '@ui-common/vue-button';
import VueFormControl from '@ui-common/vue-form-control';
import VueSettlementSelector from '@ui-common/vue-settlement-selector';
import { required, numeric, minLength, minValue, integer, email, between } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { FORM_TYPES, GTM_FORM_TYPES, BUILDING_TYPES, NAME_REGEXP, MOBILE_PHONE_REGEXP, LOADING_STATES } from '../common/constants';
import { isMobile } from '../common/mixins/is-mobile';
import pattern from '../common/validators/pattern';
import FormRow from './FormRow';
const findFirstErrorComponent = component => {
	let firstErrorComponent = component.$children.find(comp => comp.hasError);
	if (!firstErrorComponent) {
		component.$children.find(comp => {
			let hasError = findFirstErrorComponent(comp);
			if (hasError) {
				firstErrorComponent = hasError;
			}
			return hasError;
		});
	}
	return firstErrorComponent;
};
export default {
	name: 'AppraiserForm',
	mixins: [validationMixin, isMobile],
	data: () => ({
		model: {
			irszam: null,
			telepules: null,
			cim: null,
			hazszam: null,
			tipus: null,
			epitesIdeje: null,
			evszam: null,
			kor: null,
			homlokzatAllapot: null,
			falSzerkezet: null,
			telekMeret: null,
			alapterulet: null,
			szobakSzama: null,
			allapot: null,
			emeletiLakas: null,
			komfortFokozat: null,
			nev: null,
			email: null,
			telefon: null,
			hozzajarulas: false,
			megkeresesHozzajarulas: false,
			ingatlanhitel: null,
			captchaText: null
		},
		szobakSzama: null,
		felszobakSzama: null,
		settlement: null,
		constructionDateOptions: [{ key: true, value: 'Tudom a pontos évszámot' }, { key: false, value: ' Az azóta eltelt évek számát tudom' }]
	}),
	props: {
		initData: {
			required: true
		},
		type: {
			required: true,
			type: String
		},
		contactDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		appraisalDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		personalizedOfferDataManagementDocumentUrl: {
			required: true,
			type: String
		},
		personalizedOfferDataProtectionDocumentUrl: {
			required: true,
			type: String
		},
		submitState: {
			required: true,
			type: String
		},
		zipSearchState: {
			required: true,
			type: String
		},
		settlements: {
			required: true
		},
		captchaImg: {
			required: true
		},
		captchaError: {
			required: true
		},
		gtmPageInitForm: String,
		gtmPageInitPrefix: String
	},
	validations() {
		return {
			szobakSzama: {
				integer,
				minValue: minValue(0)
			},
			felszobakSzama: {
				integer,
				minValue: minValue(0)
			},
			model: {
				irszam: {
					required,
					numeric,
					minLength: minLength(4)
				},
				telepules: {
					required
				},
				cim: {
					required,
					minLength: minLength(2)
				},
				hazszam: {
					required
				},
				tipus: {
					required
				},
				epitesIdeje: {
					required
				},
				evszam: this.model.epitesIdeje ? { required, numeric, minLength: minLength(4), between: between(1800, new Date().getFullYear()) } : {},
				kor: this.model.epitesIdeje === false ? { required } : {},
				homlokzatAllapot: {
					required
				},
				falSzerkezet: this.model.tipus == BUILDING_TYPES.TARSAS_DUMMY ? { required } : {},
				telekMeret: this.model.tipus == BUILDING_TYPES.CSALAD_DUMMY ? { required, numeric } : {},
				szobakSzama: {
					required,
					minValue: minValue(0.5)
				},
				alapterulet: {
					required,
					numeric
				},
				allapot: {
					required
				},
				emeletiLakas: this.model.tipus == BUILDING_TYPES.TARSAS_DUMMY ? { required } : {},
				komfortFokozat: {
					required
				},
				nev:
					this.type == FORM_TYPES.CUSTOMER || this.type == FORM_TYPES.VENDOR
						? { required, minLength: minLength(5), pattern: pattern(NAME_REGEXP) }
						: {},
				email: {
					required,
					email
				},
				telefon:
					(this.type == FORM_TYPES.VENDOR && this.model.megkeresesHozzajarulas) || (this.type == FORM_TYPES.CUSTOMER && this.model.ingatlanhitel)
						? { required, pattern: pattern(MOBILE_PHONE_REGEXP) }
						: { pattern: pattern(MOBILE_PHONE_REGEXP) },
				captchaText: this.captchaImg ? { required } : {},
				hozzajarulas: this.type == FORM_TYPES.CUSTOMER || this.type == FORM_TYPES.VENDOR ? { checked: value => value === true } : {},
				ingatlanhitel: this.type == FORM_TYPES.CUSTOMER ? { required } : {}
			}
		};
	},
	components: {
		VueInput,
		VueSelect,
		VueSelectOption,
		VueRadioGroup,
		VueMobilephoneInput,
		VueCaptcha,
		VueCheckbox,
		VueTooltip,
		VueErrorMessage,
		FormRow,
		VueButton,
		VueFormControl,
		VueSettlementSelector
	},
	watch: {
		noOfRooms: {
			handler(val) {
				this.model.szobakSzama = val;
			},
			immediate: true
		},
		settlement(val) {
			if (val) {
				this.model.irszam = val.post;
				this.model.telepules = val.settlement;
			} else {
				this.model.irszam = null;
				this.model.telepules = null;
			}
		},
		captchaError(val) {
			if (val) {
				this.model.captchaText = null;
			}
		},
		'model.tipus'() {
			this.model.falSzerkezet = null;
			this.model.telekMeret = null;
			this.model.emeletiLakas = null;
		},
		'model.epitesIdeje'() {
			this.model.kor = null;
			this.model.evszam = null;
		}
	},
	computed: {
		formTypes() {
			return FORM_TYPES;
		},
		loadingStates() {
			return LOADING_STATES;
		},
		buildingTypes() {
			return BUILDING_TYPES;
		},
		noOfRooms() {
			let noOfRooms = parseInt(this.szobakSzama, 10);
			let noOfHalfRooms = parseInt(this.felszobakSzama, 10);
			noOfRooms = noOfRooms || 0;
			noOfHalfRooms = noOfHalfRooms || 0;
			return noOfHalfRooms * 0.5 + noOfRooms;
		}
	},
	methods: {
		jumpToFirstError() {
			this.$nextTick(() => {
				const firstErrorComponent = findFirstErrorComponent(this);
				if (firstErrorComponent) {
					const firstErrorInput = firstErrorComponent.$el.parentNode.querySelector('input');
					if (firstErrorInput) {
						firstErrorInput.focus();
					}
				}
			});
		},
		async sendForm() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.jumpToFirstError();
			} else {
				this.$emit('on-submit', this.model);
			}
		}
	},
	created() {
		if (isMobile) {
			this.model.epitesIdeje = this.constructionDateOptions[0].key;
		}
		if (this.gtmPageInitForm && this.gtmPageInitPrefix) {
			const gtmPageType = `${this.gtmPageInitPrefix} - ${GTM_FORM_TYPES[this.type]} ${this.gtmPageInitForm}`;
			this.$gtm.trackEvent({
				event: 'pageInit',
				pageType: gtmPageType
			});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" src="@ui-common/vue-radio-group/dist/vue-radio-group.css"></style>
<style lang="css" src="@ui-common/vue-tooltip/dist/vue-tooltip.css"></style>
<style lang="css" src="@ui-common/vue-button/dist/vue-button.css"></style>
<style lang="css" src="@ui-common/vue-input/dist/vue-input.css"></style>
<style lang="css" src="@ui-common/vue-settlement-selector/dist/vue-settlement-selector.css"></style>
<style lang="css" src="@ui-common/vue-error-message/dist/vue-error-message.css"></style>
<style lang="css" src="@ui-common/vue-mobilephone-input/dist/vue-mobilephone-input.css"></style>
<style lang="css" src="@ui-common/vue-captcha/dist/vue-captcha.css"></style>
<style lang="css" src="@ui-common/vue-checkbox/dist/vue-checkbox.css"></style>
<style lang="css" src="@ui-common/vue-select/dist/vue-select.css"></style>
<style lang="css" src="@ui-common/vue-form-control/dist/vue-form-control.css"></style>
<style lang="scss" src="./AppraiserForm.scss" scoped></style>
<style lang="scss">
@import '@sfui/helpers/_queries.scss';

.appr-form-row--radio .vue-radio-group__label {
	@media screen and ($tablet) {
		padding-right: 10px;
	}
}

.appr-input-dropdown .appr-form-row--radio .vue-radio-group__pair {
	@media screen and ($tablet) {
		margin-bottom: 20px;
	}
}

.appr-form-row--radio .appr-lastgroup .vue-radio-group__container {
	@media screen and ($tablet) {
		float: left;
		margin-right: 20px;
	}
}

.appr-form-row .sf-settlement-selector .sf-input {
	display: inline-block;
}

.appr-form-row .sf-settlement-selector__select-wrapper {
	display: inline-block;
	margin-left: 30px;
}

.appr-form-row .sf-settlement-selector__select-wrapper .sf-select__options {
	width: auto;
}

.appr-form-row--radio .sf-error__msg {
	@media screen and ($mobile-only) {
		margin-top: 20px;
	}
}

.appr-form-row--radio-inline-mobile {
	.vue-radio-group__container {
		@media screen and ($mobile-only) {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
		}
	}

	.vue-radio-group__pair {
		@media screen and ($mobile-only) {
			margin-right: 20px;
		}
	}
}

.appr-radio-dropdown .sf-error__msg--bottom {
	margin-top: -20px;
	margin-bottom: 20px;
}

.appr-form-row .sf-mobilephone .sf-mobilephone__prefix {
	line-height: 43px;
}

.appr-form-row .sf-mobilephone .sf-mobilephone__postfix {
	margin-top: -2px;
}
</style>
